/**
 * DID admin API contracts.
 *
 * Used by `apps/api/src/routes/dids/*`. Mirrors the `public.did_index` table,
 * which is the SINGLE source of truth for inbound routing (the former
 * per-tenant `did_routing` mirror and `inbound_numbers` table were collapsed
 * into it).
 */
import { z, didPhoneSchema, tenantSlugSchema } from '@kc3/validation';
export const DidDirectionSchema = z.enum(['inbound', 'outbound']);
/**
 * Stored status. The LIST response additionally folds a soft delete
 * (`deleted_at IS NOT NULL`) into a third 'deleted' value for display only.
 */
export const DidStatusSchema = z.enum(['active', 'disabled']);
export const CreateDidRequestSchema = z.object({
    did: didPhoneSchema,
    tenantSlug: tenantSlugSchema,
    name: z.string().trim().max(120).optional().nullable(),
    description: z.string().trim().max(500).optional().nullable(),
    callerIdNamePrefix: z.string().trim().max(100).optional().nullable(),
    direction: DidDirectionSchema.optional().default('inbound'),
    destinationType: z.string().min(1, { message: 'Invalid type' }).optional(),
    destination: z.string().optional().nullable(),
    status: DidStatusSchema.optional().default('active'),
});
export const UpdateDidRequestSchema = z
    .object({
    did: didPhoneSchema.optional(),
    name: z.string().trim().max(120).nullable().optional(),
    description: z.string().trim().max(500).nullable().optional(),
    callerIdNamePrefix: z.string().trim().max(100).nullable().optional(),
    direction: DidDirectionSchema.optional(),
    destinationType: z.string().min(1, { message: 'Invalid type' }).nullable().optional(),
    destination: z.string().nullable().optional(),
    status: DidStatusSchema.optional(),
})
    .refine((v) => v.did !== undefined ||
    v.name !== undefined ||
    v.description !== undefined ||
    v.callerIdNamePrefix !== undefined ||
    v.direction !== undefined ||
    v.destinationType !== undefined ||
    v.destination !== undefined ||
    v.status !== undefined, { message: 'At least one field must be provided' });
export const DidResponseSchema = z.object({
    id: z.string().uuid(),
    did: didPhoneSchema,
    tenantId: z.string().uuid(),
    tenantSlug: tenantSlugSchema,
    direction: DidDirectionSchema,
    name: z.string().nullable(),
    description: z.string().nullable(),
    callerIdNamePrefix: z.string().nullable(),
    destinationType: z.string().nullable(),
    destination: z.string().nullable(),
    status: z.enum(['active', 'disabled', 'deleted']),
    deletedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=dids.js.map